import { FILTER_SAVED } from '../actionTypes/user.types';

export function saveFilterUser(data: object) {
  return {
    type: FILTER_SAVED,
    payload: {
      ...data,
    },
  };
}
